import React from "react";
import { MDBContainer, MDBRow, MDBTypo } from "mdbreact";
import { Helmet } from "react-helmet";

import Layout from "../components/Layout";

import ReactMarkdown from "react-markdown";

import signwriter from "../images/headers/SWHeader.jpg";
import blank from "../images/headers/Blank.jpg"

import text from "../text/text.json"

import ColourImage from "../components/ColourImage";
import HoverSubImage from "../components/HoverSubImage";
import { Typography } from "@material-ui/core";

function Signwriter() {

    return (
        <>
        <Helmet>
            <title>Artistic Wizard | Signwriter</title>
        </Helmet>
        <Layout>
        <ColourImage text="" overlay="" image={signwriter}/>
            <MDBContainer style={{ padding:"20px"}}>
          <ReactMarkdown>{text.signwriter.header1}</ReactMarkdown>
          <ReactMarkdown>{text.signwriter.body1}</ReactMarkdown>
          <ReactMarkdown>{text.signwriter.body2}</ReactMarkdown>
          <ReactMarkdown>{text.signwriter.header2}</ReactMarkdown>
          <ReactMarkdown>{text.signwriter.body4}</ReactMarkdown>
          <ReactMarkdown>{text.signwriter.body5}</ReactMarkdown>
        <MDBContainer style={{padding:"10px"}}>
        <MDBRow>
          <HoverSubImage text="BUSINESS BRANDING" body="Services to define and position your business" overlay="blue-strong" image={blank} page="/signwriter/business-branding"/>
          <HoverSubImage text="CUSTOM ARTISTIC" body="Traditional methods – distinctive and unique" overlay="pink-strong" image={blank} page="/signwriter/custom-artistic"/>
          <HoverSubImage text="3D LETTERING & ILLUMINATED" body="Emphasise & add interest" overlay="green-strong" image={blank} page="/signwriter/Lettering-and-Illumination"/>
          <HoverSubImage text="EXTERIOR SIGNS" body="Visibility and brand identity" overlay="brown-strong" image={blank} page="/signwriter/exterior"/>
          <HoverSubImage text="INTERIOR SIGNS" body="Set the vibe" overlay="purple-strong" image={blank} page="/signwriter/interior"/>
          <HoverSubImage text="VEHICLE SIGNS" body="Broadcast on the move and when parked" overlay="indigo-strong" image={blank} page="/signwriter/vehicle"/>
          <HoverSubImage text="DESIGN SERVICE" body="Complete sign solutions" overlay="stylish-strong" image={blank} page="/signwriter/design-service"/>
          <HoverSubImage text="SERVICE AREAS" body="We come to you" overlay="blue-grey-strong" image={blank} page="/signwriter/service-areas"/>
          <MDBTypo><sub><b>Note</b>: Artistic Wizard may be requested and supplied images by clients to produce hand-painted reproduction or restoration brushwork for advertising and corporate signage purposes which may involve copyright. This site may contain copyright content that is subject to copyright permission or its application constitutes a fair use which allows certain uses of content without the copyright owner’s permission. The Artistic Wizard website may include use of some of these reproduction or restoration images and logos for information or display purposes to demonstrate physical artworks produced by Artistic Wizard.</sub></MDBTypo>
        </MDBRow>
        </MDBContainer>
      </MDBContainer>
      </Layout>
      </>
    )
}

export default Signwriter;